import React from 'react';

export default class Benefit extends React.Component {
  render() {
    return <div className="content">
      <h1 className="title is-3">Benefits of Measure-based Guidance</h1>
      <p>Engagement with a purpose:&nbsp;<strong>Better Guidance for Better care.</strong></p>
      <p><strong>3 Easy Steps</strong> to better guidance:&nbsp;</p>
      <p><strong>1.&nbsp;Shift:</strong> Collect routine information and ratings at home instead of during your appointment.</p><p><strong>2. Sift:</strong> &nbsp;CCI's cloud-based analytics organize your responses into a meaningful "pre-assessment report"</p><p><strong>3.&nbsp;Gift:</strong>&nbsp;Share the Pre-assessment with your care partners. &nbsp;Help your clinician give you the benefit of formal assessments and have more time for better understanding.</p>
      <p>Engaged practice reduces frustration by changing the clinical workflow:&nbsp;</p><p>The pre-assessment report is an easy way for patients and clinicians to have the advantage of measure-based guidance for their clinical decision making.</p><p>The gift of extra time gives care providers the opportunity to apply higher skills during clinical visits.&nbsp;</p><p>By engaging with the CCI pre-assessment process at home, patient inputs are collected ahead of visits. Then CCI's data analytic processes sifts the information and transforms it into clinically meaningful displays. &nbsp;</p>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/components/pages/more/Benefit.js